import { useCallback } from 'react'
import type { SearchFormRef } from 'components/Search'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import type { GlobalSearchAction } from 'contexts/GlobalSearch/GlobalSearchState'
import { DATE_SEARCH_OPTION_IDS } from 'constants/search'
import { buildSelectDatesSearchParams } from 'lib/search/selectDatesUtils'
import { setPendingSelectDatesPrompt } from 'lib/search/pendingSelectDatesPromptStore'

interface Params {
  vertical: 'hotels' | 'homes-and-villas'
  isMobileScreen: boolean
  toggleSearchVertical: (vertical: App.SearchVertical, options?: { withDateSelect?: boolean }) => void
  dispatchRef: React.MutableRefObject<React.Dispatch<GlobalSearchAction> | null>
  formRef: React.RefObject<SearchFormRef | null>
}

export default function useOnSelectDatesPrompt({
  vertical,
  isMobileScreen,
  toggleSearchVertical,
  dispatchRef,
  formRef,
}: Params) {
  return useCallback((offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | App.VillaOffer | App.VillaOfferSummary) => {
    const { propertyId, propertyName, propertySearchItem } = buildSelectDatesSearchParams(offer)

    if (isMobileScreen) {
      setPendingSelectDatesPrompt({ vertical, propertyId, propertyName })
      toggleSearchVertical(vertical, { withDateSelect: true })
    } else {
      dispatchRef.current?.({ type: GlobalSearchStateActions.SET_SEARCH_ITEM, searchItem: propertySearchItem })
      dispatchRef.current?.({ type: GlobalSearchStateActions.SET_DATE_SEARCH_OPTION, optionId: DATE_SEARCH_OPTION_IDS.SPECIFIC })
      formRef.current?.form.current.scrollIntoView()
      formRef.current?.openDatePickerMenu()
    }
  }, [vertical, isMobileScreen, toggleSearchVertical, dispatchRef, formRef])
}
